exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.stepCounter___1ESWE {\n  color: #767676;\n  font-size: 12px;\n  font-weight: 500;\n}\n.dot___2P1pn {\n  background-color: #d9d9d9;\n  border-radius: 4px;\n  height: 8px;\n  margin: 0 2px;\n  width: 8px;\n}\n.dot___2P1pn.active___1Wqam {\n  background-color: #0075ae;\n}\n@media (max-width: 767px) {\n  .dot___2P1pn {\n    display: none;\n  }\n}\n.dotsBox___KcEOS {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: 0 auto;\n}\n", ""]);

// exports
exports.locals = {
	"stepCounter": "stepCounter___1ESWE",
	"dot": "dot___2P1pn",
	"active": "active___1Wqam",
	"dotsBox": "dotsBox___KcEOS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/BreadCrumbs/styles.module.less
// module id = 1647
// module chunks = 71